// Constants
import { ItemTypes } from "@ms/uno-constants/lib/local/DndConstants";
// Utilities
import React from "react";
import { useDrop } from "react-dnd";
/**
 * The component with a drop zone that covers the entire body to catch drop events
 */ export function DndDropZone(props) {
    const [_, bodyDropRef] = useDrop(()=>({
            accept: [
                ItemTypes.Card,
                ItemTypes.Column
            ],
            drop: ()=>{
            // do nothing, just need to catch the drop event
            // this is the workaround as react-dnd does not support return animation when using custom drag layer
            }
        }));
    React.useEffect(()=>{
        bodyDropRef(document.body);
        return ()=>{
            bodyDropRef(null);
        };
    }, [
        bodyDropRef
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, props.children);
}
